<!-- 特殊单视频播放 Pop 组件 -->
<!-- 在运煤和物流处使用 -->
<template>
  <div v-if="status" class="back_mask">
    <div :class="resolving !== 1920 ? 'prop' : 'prop1920'">
      <video class="video" :src="data.src" autoplay />
      <div class="close" @click="close()" />
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  components: {},
  // import引入的组件需要注入到对象中才能使用
  props: {
    data: Object,
    status: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 这里存放数据
    return {
      currentPage: 0,
      resolving: ""
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (window.screen.width <= 1920 && window.screen.width > 1366) {
      this.resolving = 1920;
    } else if (window.screen.width > 1920) {
      this.resolving = 1920;
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  // 方法集合
  methods: {
    close() {
      this.$emit("close-pop", null);
      //显示左上后退和右上回家按钮
      this.$store.commit("setHomeBack", true);
      this.$store.commit("setSelectTagImg", true);
      this.$store.commit("setImgListStatus", true);
    },
    getAction(item) {
      this.currentPage = Number(item);
      //
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.back_mask {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  .prop {
    .video {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: fill;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .close {
      width: 4%;
      height: 7%;
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/close.png");
      background-size: 100% 100%;
      position: absolute;
      right: -2%;
      top: -3%;
      z-index: 100;
    }
    position: absolute;
    width: 76vw;
    height: 93vh;
    background-color: white;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .prop1920 {
    .video {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: fill;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .close {
      width: 4%;
      height: 7%;
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/close.png");
      background-size: 100% 100%;
      position: absolute;
      right: -2%;
      top: -3%;
      z-index: 100;
    }
    position: absolute;
    width: 80.2vw;
    height: 93vh;
    background-color: white;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .click_btn {
    cursor: pointer;
    position: absolute;
    z-index: 1;
  }
  .click_btn:hover {
    transform: scale(1.1, 1.1);
  }
  .close:hover {
    transform: scale(1.1, 1.1);
  }
}
</style>
